import { render, staticRenderFns } from "./ProjectsDash.vue?vue&type=template&id=4b983e30"
import script from "./ProjectsDash.vue?vue&type=script&lang=js"
export * from "./ProjectsDash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports